import React from "react";
import styles from "./EditFormButtonRenderer.module.css";
import { EditFormButtonRendererProps } from "./EditFormButtonRenderer.utils";

/**
 * EditFormButtonRenderer Component
 *
 * Renders a button with a pencil icon to edit either the onboarding or acceptance form
 * for a given client. Displays the corresponding form name alongside the button.
 * On click, it sets the form ID, client ID, and opens the editor modal.
 */
const EditFormButtonRenderer: React.FC<EditFormButtonRendererProps> = ({
  setFormPurpose,
  setClientRowData,
  setClientMasterId,
  setClientEditorShow,
  rowData,
  formType,
}) => {
  // const { formId, formName } = getFormDetails(formType, rowData);
  const clientName = rowData && rowData["Client Name"] ? rowData["Client Name"] : ""
  const clientMasterId = rowData?.ClientMasterId;
  const editForm = () => {
    setClientRowData(rowData);
    setClientMasterId(clientMasterId);
    setFormPurpose(formType);
    setClientEditorShow(true);
  };
  return rowData ? (
    <div className={styles.editFormButtonWrapper} onClick={() => editForm()}>
      <div>{clientName ? clientName : ""}</div>
    </div>
  ) : (
    <></>
  );
};

export default EditFormButtonRenderer;
